import "../../Format";
import "./Base";
import "./OL3/WMS";

/** @namespace GIS.Map.Layer */
NS("GIS.Map.Layer");

/**
 * @class
 * @extends GIS.Map.Layer.Base
 */
GIS.Map.Layer.WMS = Class(GIS.Map.Layer.Base, /** @lends GIS.Map.Layer.WMS.prototype */ {
    vendors: {
        "ol3": GIS.Map.Layer.OL3.WMS
    },
    // options
    singleTile: false,
    tileSize: [256, 256],
    wrapX: true,
    url: null,
    crossOrigin: "anonymous",
    format: GIS.Format.PNG,
    /** @type {string[]} Additional url tokens */
    urlParams: [],
    params: {
        version: "1.3.0",
        layers: null,
        format: GIS.Format.PNG,
        styles: null,
        sld: null,
        transparent: true,
        filter: null
    },
    info: {
        query_layers: null,
        info_format: GIS.Format.HTML
    },
    legend: {
        layer: null,
        format: GIS.Format.PNG,
        style: null,
        width: null,
        height: null
    },
    /**
     * @inheritDoc
     */
    initialize()
    {
        this.ParentCall();

        this.layer.on("click", this.onLayerClick, this);
    },
    /** @inheritDoc */
    optionsNames() {
        return this.ParentCall().concat(["url", "urlParams", "wrapX", "singleTile", "tileSize", "crossOrigin", "format",
            "params", "info", "legend"
        ]);
    },
    /** @inheritDoc */
    prepareOptions(options)
    {
        options = this.Parent(options);

        if (options.format != null) {
            _.set(options, "params.format", options.format);
        }

        if (options.tileSize != null && !_.isArray(options.tileSize)) {
            options.tileSize = [_.parseInt(options.tileSize)];
        }

        return options;
    },
    /**
     * @param {{pixel: number[], coordinate: number[]}} e
     * @fires GIS.Map.Layer.Tile#click
     * @protected
     */
    onLayerClick(e)
    {
        /**
         * @event GIS.Map.Layer.Tile#click
         * @type {{pixel: number[], coordinate: number[]}}
         */
        this.emit("click", e);
    },
    /**
     * @returns {number}
     */
    getType()
    {
        return GIS.LayerType.Raster;
    },
    /**
     * Executes GetFeatureInfo request
     *
     * @param {number[]} coordinate
     * @param {Object} [options] Additional options
     * @returns {Promise}
     */
    GetFeatureInfo(coordinate, options)
    {
        return this.layer.GetFeatureInfo(coordinate, options);
    },
    /**
     * @returns {Promise}
     */
    GetCapabilities()
    {
        return this.layer.GetCapabilities();
    },
    /**
     * @returns {string}
     */
    getGetCapabilitiesURL()
    {
        return this.layer.getGetCapabilitiesURL();
    },
    /**
     * @param {number[]} coordinate
     * @param {Object} options
     * @returns {string}
     */
    getGetFeatureInfoURL(coordinate, options)
    {
        return this.layer.getGetFeatureInfoURL(coordinate, options);
    },
    /**
     * @param {Object} options
     * @returns {string}
     */
    getGetLegendGraphicURL(options)
    {
        return this.layer.getGetLegendGraphicURL(options);
    }
});
